(function () {
  var selector = '[data-deferred-section]';

  function hydrate(placeholder) {
    if (!placeholder || placeholder.dataset.deferredSectionLoaded === 'true') return;

    var template = placeholder.previousElementSibling;
    if (!template || !template.matches('[data-deferred-section-template]')) return;

    placeholder.dataset.deferredSectionLoaded = 'true';

    var fragment = template.content.cloneNode(true);
    var section = fragment.querySelector('[data-section-id]');
    template.replaceWith(fragment);
    placeholder.remove();

    if (section) {
      section.dispatchEvent(new CustomEvent('theme:deferred-section:load', { bubbles: true }));
    }
  }

  function observe(root) {
    var placeholders = root.matches && root.matches(selector)
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll(selector));

    if (!('IntersectionObserver' in window)) {
      placeholders.forEach(hydrate);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrate(entry.target);
      });
    }, { rootMargin: '1000px 0px' });

    placeholders.forEach(function (placeholder) {
      observer.observe(placeholder);
    });
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
